import TYPES from '../actions/types';

const INITIAL_STATE = {
  getSummary: null,
  getSummaryError: false,
}

export default function(state = INITIAL_STATE, action) {
  switch(action.type) {
    case TYPES.summaryData:
      return {
        ...state,
        getSummary: action.payload.summary,
        getSummaryError: false,
      };

    case TYPES.summaryRequestError:
      return { ...state, getSummaryError: true };

    default:
      return state;
  }
}
